module.exports = __webpack_public_path__ + "img/header-memoireRingsBestseller@2x.952b714.webp";